import { render, staticRenderFns } from "./AttackList.vue?vue&type=template&id=22159404"
import script from "./AttackList.vue?vue&type=script&lang=js"
export * from "./AttackList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports